export default "__VITE_ASSET__DhYJ3JNs__"